import useCollection from '@actions/services/firestore/browser/toolbox/useCollection';
import {
    EntityGet,
    HookCollectionOpts,
    HookReturnCollection,
} from '@actions/services/firestore/browser/types';
import { Toolbox } from '@actions/services/firestore/browser/toolbox/types';
import { query, where } from '@actions/services/firestore/browser-exports';

type UseToolboxesOptions = HookCollectionOpts<EntityGet<Toolbox>> & {
    agentId: string;
};

type UseToolboxesResult = HookReturnCollection<EntityGet<Toolbox>>;

const useToolboxes = ({ agentId, ...opts }: UseToolboxesOptions): UseToolboxesResult => {
    return useCollection({
        listQueryFn: ref =>
            query(ref, where('removed', '==', false), where('agentId', '==', agentId)),
        track: [agentId, ...(opts.track || [])],
        ...opts,
    });
};

export default useToolboxes;
